<h3>Edit Details</h3>
<mat-dialog-content>
    <div class="form-row">
        <mat-form-field appearance="outline" class="full-width">
            <mat-label>Property Type</mat-label>
            <mat-select [(ngModel)]="property.propertyType">
                <mat-option [value]="null">Select Property Type</mat-option>
                <mat-option *ngFor="let type of propertyTypes" [value]="type">
                    {{ type | titlecase }}
                </mat-option>
            </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" class="full-width">
            <mat-label>Square Footage</mat-label>
            <input matInput type="number" [(ngModel)]="property.sizeSqft" />
        </mat-form-field>   
        <mat-form-field appearance="outline" class="full-width">
            <mat-label>Bedrooms</mat-label>
            <input matInput type="number" placeholder="" [(ngModel)]="property.bedrooms">
        </mat-form-field>
        <mat-form-field appearance="outline" class="full-width">
            <mat-label>Sleeps</mat-label>
            <input matInput type="number" placeholder="" [(ngModel)]="property.sleeps">
        </mat-form-field>
        <mat-form-field appearance="outline" class="full-width">
            <mat-label>Bathrooms</mat-label>
            <input matInput type="number" placeholder="" [(ngModel)]="property.bathrooms">
        </mat-form-field>
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-flat-button class="metallic-text-btn-red" type="button" (click)="cancel.emit()"><mat-icon matPrefix>cancel</mat-icon>Canel</button>
    <button mat-flat-button class="metallic-text-btn-blue" type="button" (click)="save.emit(property)"><mat-icon matPrefix>save</mat-icon>Save</button>
</mat-dialog-actions>
